import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=c8a1d466&scoped=true&"
import script from "./Species.vue?vue&type=script&lang=js&"
export * from "./Species.vue?vue&type=script&lang=js&"
import style0 from "./Species.vue?vue&type=style&index=0&id=c8a1d466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1d466",
  null
  
)

export default component.exports